module.exports = __webpack_public_path__ + "img/member-icon3.b7f5a25c.png";